import React from 'react';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

const TooltipButton = (props) => {
  const {
    children, variant, onClick, size,
    tooltip, ariaControls, ariaExpanded,
  } = props;
  return (
    <OverlayTrigger placement="top" overlay={(<Tooltip>{tooltip}</Tooltip>)}>
      <Button
        variant={variant}
        size={size}
        onClick={onClick}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
      >
        {children}
      </Button>
    </OverlayTrigger>
  );
};

TooltipButton.propTypes = {
  variant: PropTypes.oneOf(['success', 'danger', 'secondary', 'warning', 'info', 'dark']).isRequired,
  size: PropTypes.oneOf(['lg', 'sm']),
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  ariaControls: PropTypes.string,
  ariaExpanded: PropTypes.string,
};

TooltipButton.defaultProps = {
  children: undefined,
  size: undefined,
  ariaControls: undefined,
  ariaExpanded: undefined,
};

export default TooltipButton;
